// Mock data for AI & ML Course Landing Page

export const courseModules = [
  {
    id: 1,
    title: "Introduction to AI & ML",
    description: "Fundamentals of Artificial Intelligence and Machine Learning, basic concepts, and real-world applications",
    duration: "4 weeks",
    topics: ["AI History & Evolution", "ML Basics", "Types of Learning", "AI Ethics"],
    icon: "brain"
  },
  {
    id: 2,
    title: "Python for Data Science",
    description: "Master Python programming with NumPy, Pandas, and data visualization libraries",
    duration: "3 weeks",
    topics: ["Python Basics", "NumPy & Pandas", "Matplotlib & Seaborn", "Data Preprocessing"],
    icon: "code"
  },
  {
    id: 3,
    title: "Supervised Learning",
    description: "Linear regression, logistic regression, decision trees, and ensemble methods",
    duration: "5 weeks",
    topics: ["Regression Models", "Classification", "Decision Trees", "Random Forest", "Gradient Boosting"],
    icon: "target"
  },
  {
    id: 4,
    title: "Unsupervised Learning",
    description: "Clustering algorithms, dimensionality reduction, and anomaly detection techniques",
    duration: "4 weeks",
    topics: ["K-Means Clustering", "Hierarchical Clustering", "PCA", "Anomaly Detection"],
    icon: "layers"
  },
  {
    id: 5,
    title: "Deep Learning & Neural Networks",
    description: "Build and train neural networks using TensorFlow and PyTorch frameworks",
    duration: "6 weeks",
    topics: ["Neural Networks", "CNNs", "RNNs", "Transfer Learning", "Model Optimization"],
    icon: "network"
  },
  {
    id: 6,
    title: "Natural Language Processing",
    description: "Text processing, sentiment analysis, transformers, and large language models",
    duration: "5 weeks",
    topics: ["Text Preprocessing", "Word Embeddings", "Transformers", "BERT & GPT", "LLM Applications"],
    icon: "message-square"
  },
  {
    id: 7,
    title: "Computer Vision",
    description: "Image processing, object detection, segmentation, and advanced CV applications",
    duration: "5 weeks",
    topics: ["Image Processing", "Object Detection", "Image Segmentation", "Face Recognition", "GANs"],
    icon: "eye"
  },
  {
    id: 8,
    title: "MLOps & Deployment",
    description: "Deploy ML models to production, monitoring, and maintaining AI systems at scale",
    duration: "4 weeks",
    topics: ["Model Deployment", "Docker & Kubernetes", "CI/CD", "Model Monitoring", "Scaling ML Systems"],
    icon: "rocket"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What are the prerequisites for this course?",
    answer: "Basic programming knowledge is helpful but not mandatory. We cover Python fundamentals in the course. A background in mathematics (basic algebra and statistics) will be beneficial but we provide refresher materials for all concepts."
  },
  {
    id: 2,
    question: "How long does it take to complete the course?",
    answer: "The complete course is designed to be completed in 6-8 months with 10-15 hours of study per week. However, you have lifetime access, so you can learn at your own pace."
  },
  {
    id: 3,
    question: "Will I get a certificate upon completion?",
    answer: "Yes! You'll receive an industry-recognized certificate upon successful completion of all modules and projects. The certificate can be shared on LinkedIn and added to your resume."
  },
  {
    id: 4,
    question: "What kind of projects will I work on?",
    answer: "You'll build 12+ real-world projects including: predictive models, chatbots, image classification systems, recommendation engines, and deploy production-ready ML applications. All projects are portfolio-ready."
  },
  {
    id: 5,
    question: "Do you provide career support?",
    answer: "Absolutely! We offer resume reviews, mock interviews, portfolio building guidance, and job referrals to our partner companies. Our dedicated career support team helps you land your dream AI/ML role."
  },
  {
    id: 6,
    question: "What's the refund policy?",
    answer: "We offer a 30-day money-back guarantee. If you're not satisfied with the course content within the first 30 days, you can request a full refund—no questions asked."
  },
  {
    id: 7,
    question: "Can I access course materials after completion?",
    answer: "Yes! You get lifetime access to all course materials, including future updates. As AI/ML evolves, we continuously update our content, and you'll get all updates for free."
  },
  {
    id: 8,
    question: "Is there any live instructor support?",
    answer: "Yes! We conduct live doubt-clearing sessions twice a week. You also get access to our 24/7 community forum where instructors and peers help answer your questions within hours."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "ML Engineer at Google",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    text: "This course transformed my career! The hands-on projects and real-world applications gave me the confidence to land my dream job at Google. The instructors are incredibly knowledgeable."
  },
  {
    id: 2,
    name: "Rahul Verma",
    role: "Data Scientist at Microsoft",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    text: "Best AI/ML course out there! The curriculum is up-to-date with industry standards. I went from zero ML knowledge to deploying production models in just 6 months."
  },
  {
    id: 3,
    name: "Anjali Mehta",
    role: "AI Researcher at Stanford",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
    text: "The depth of content is impressive. From basics to advanced topics like transformers and GANs, everything is explained clearly. The career support helped me get into Stanford's AI lab."
  }
];

export const courseFeatures = [
  {
    icon: "video",
    title: "200+ HD Video Lectures",
    description: "High-quality video content with clear explanations and visual demonstrations"
  },
  {
    icon: "code-2",
    title: "50+ Coding Exercises",
    description: "Hands-on coding challenges to reinforce your learning and build muscle memory"
  },
  {
    icon: "folder-open",
    title: "12+ Real-World Projects",
    description: "Portfolio-ready projects that showcase your skills to potential employers"
  },
  {
    icon: "users",
    title: "Live Doubt Sessions",
    description: "Twice-weekly live sessions with expert instructors to clarify all your doubts"
  },
  {
    icon: "award",
    title: "Industry Certificate",
    description: "Recognized certification that adds credibility to your resume and LinkedIn"
  },
  {
    icon: "briefcase",
    title: "Career Support",
    description: "Resume reviews, mock interviews, and job referrals to partner companies"
  }
];

export const stats = [
  { label: "Students Enrolled", value: "15,000+" },
  { label: "Average Salary Hike", value: "150%" },
  { label: "Hiring Partners", value: "200+" },
  { label: "Course Rating", value: "4.9/5" }
];

// Mock chatbot responses
export const mockChatbotResponses = {
  greeting: "Hello! 👋 I'm your AI course assistant. I can help you with information about the syllabus, course structure, fees, career opportunities, and more. What would you like to know?",
  syllabus: "Our comprehensive syllabus covers 8 major modules: 1) AI & ML Fundamentals, 2) Python for Data Science, 3) Supervised Learning, 4) Unsupervised Learning, 5) Deep Learning, 6) NLP, 7) Computer Vision, and 8) MLOps. Each module includes hands-on projects and real-world applications. Would you like details about any specific module?",
  fees: "The course is priced at ₹49,999 (or $599 USD). We offer flexible payment plans: Pay in full and get 20% discount, or choose EMI options starting at ₹5,555/month for 10 months. We also have a 30-day money-back guarantee!",
  career: "Our graduates work at top companies like Google, Microsoft, Amazon, and leading AI startups. Average salary hike is 150%. We provide dedicated career support including resume reviews, mock interviews, and job referrals to 200+ hiring partners.",
  duration: "The complete course takes 6-8 months to finish with 10-15 hours of weekly commitment. However, you get lifetime access, so you can learn at your own pace. Fast learners complete it in 4-5 months!",
  certificate: "Yes! You'll receive an industry-recognized certificate upon completion. It's verified, shareable on LinkedIn, and adds significant value to your resume. Many of our students have landed interviews just because of this certificate.",
  projects: "You'll build 12+ real-world projects including: Spam Classifier, Stock Price Predictor, Chatbot using NLP, Image Classification System, Recommendation Engine, and many more. All projects are production-ready and perfect for your portfolio.",
  default: "That's a great question! You can ask me about: Course syllabus, Fees & payment plans, Career opportunities, Course duration, Certificate, Projects, Prerequisites, or anything else about the course. What would you like to know?"
};
